function loadClient({ output, services }) {
  services.Http.post('/api/load', {}).then(output.success).catch(output.error)
}

loadClient.async = true
export default loadClient



// WEBPACK FOOTER //
// ./src/modules/app/actions/loadClient.js